<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" class="nepali-calendar" id="toDate" v-model="toDate" v-else/>
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchJournal" class="p-button p-component addNewBtn btn-btm-0" label="Search"
                    icon="pi pi-search"/>
          </div>
          <div class="p-field p-col-12 p-md-7 p-mt-5">
            <a href="#" @click.prevent="exportCSV()" class="p-field p-col-12 p-md-12">
            <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
          </div>
        </div>
        <Dialogs header="Reason" :visible.sync="statusDialog"
                 :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
          <div class="col-md-12">
            <label for="reason" class="col-md-4 control-label">Reason</label>
            <div class="form-group col-md-8">
              <textarea class="form-control" rows="5" v-model="reason"></textarea>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised p-button-success" @click.prevent="updateTransactionStatus"
                    label="Send"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </template>
        </Dialogs>

      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
         
          <DataTable :value="allJournalBookLists"
                     :paginator="true" ref="po" editMode="cell"
                      :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters" class="p-datatable-gridlines"
                     data-key="id">
            <!-- <Column header="S.N" >
            </Column> -->
            <Column
              header="Miti" :sortable="true"
              field="transactionDateNepali" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDateNepali : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column header="Date" :sortable="true" field="transactionDate" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDate : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column header="Vou Type" :sortable="true" field="entryType" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.entryType : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['entryType']"/>
              </template>
            </Column>
            <Column header="Voucher" :sortable="true" field="voucher" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.voucher : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column header="Account" :sortable="true" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>
            <Column header="Narration" field="remarks">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.remarks : '' }}
              </template>
            </Column>
            <Column header="Debit" field="debitBalance"
                    filterMatchMode="contains" bodyStyle="color:#00a65a;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column header="Credit" field="creditBalance"
                    filterMatchMode="contains"
                    bodyStyle="color:#dd4b39;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>

            <Column field="txnStatus" header="Status" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['txnStatus']"/>
              </template>
              <template #editor="slotProps">
                <Dropdown
                  v-model="slotProps.data['txnStatus']" :options="statuses" @change="showReasonDialog(slotProps.data)"
                  optionLabel="label" optionValue="value" placeholder="Select a Status"
                  :disabled="slotProps.data['txnStatus']==='Accept'?true:false">
                  <template #option="slotProps">
                <span
                  :class="'product-badge status-' + slotProps.option.value.toLowerCase()">{{
                    slotProps.option.label
                  }}</span>
                  </template>
                </Dropdown>
              </template>
              <template #body="slotProps">
                {{ getStatusLabel(slotProps.data.txnStatus) }}
              </template>
            </Column>
            <!-- <Column header="closing Balance" field="closingBalance" filterField="closingBalance" filterMatchMode="contains" /> -->
            <template #empty>No record found</template>
            <Column header="Action"  >
              <template #body="slotProps">
                <Button class="p-button-raised p-button-success"
                        v-if="!renderIf(slotProps.data) && !slotProps.data.repatedTransaction && !slotProps.data.isReversed"
                        @click="openReverseTransaction(slotProps.data)" icon="pi pi-undo"/>
                <Button class="p-button-raised p-button-success"
                        v-if="renderIf(slotProps.data) && !slotProps.data.repatedTransaction && !slotProps.data.isReversed"
                        @click="openReverseTransaction(slotProps.data)" icon="pi pi-undo" disabled/>
                <Button class="p-button-raised"
                        v-if="!slotProps.data.repatedTransaction" @click="openVoucher(slotProps.data)"
                        icon="pi pi-money-bill"/>
              </template>
            </Column>
          </DataTable>
        </div>
        <ReverseDialog ref="reverseDialogs"/>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import ReverseDialog from '../commonDialogs/reverseDialog.vue'
import Button from 'primevue/button'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'

export default {
  name: 'journalBook',
  data() {
    return {
      name: '',
      fromDate: null,
      toDate: null,
      account: '',
      accountMasterId: 0,
      loading: false,
      columnList: '',
      filters: {},
      statusDialog: false,
      statusData: '',
      type: 'All',
      englishDateEnabled: true,
      reason: '',
      makerChecker: 'Pending',
      statuses: [{label: 'Accept', value: 'Accept'}, {label: 'Pending', value: 'Pending'},
        {label: 'Cancel', value: 'Cancel'}, {label: 'Deny', value: 'Deny'}, {label: 'Delete', value: 'Delete'}]
    }
  },
  computed: {
    allJournalBookLists() {
      return this.$store.state.accountingReport.allJournalPendingBookLists
    }
  },
  mounted() {
    // this.accountList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchJournal() {
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      if (this.fromDate === '' || this.toDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Date cannot be empty.', life: 10000})
        return
      }
      let journal = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: this.accountMasterId,
        type: this.type,
        makerCheckerType: this.makerChecker
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadAllPendingjournalBookList', journal)
      this.loading = false
      this.allJournalPendingBookLists = resp.data.data
      // // debugger
    },
    openReverseTransaction(data) {
      this.$refs.reverseDialogs.openReverseDialog(data)
    },
    openVoucher(data) {
      this.$router.push({name: 'voucher', params: {printData: data}})
    },
    // async accountList() {
    //   await this.$store.dispatch('accountMasterList')
    // },
    editJournalBook(data) {
      let journalEdit = {
        tranId: data.tranId,
        tranModuleType: data.tranModuleType
      }
      if (data.entryType === 'jou') {
        this.$router.push({name: 'Journal Entry', params: {journal: journalEdit}})
      } else if (data.entryType === 'rec') {
        this.$router.push({name: 'Receipt Entry', params: {receipt: journalEdit}})
      } else if (data.entryType === 'pay') {
        this.$router.push({name: 'Payment Entry', params: {payment: journalEdit}})
      }
    },
    cancel(data) {
      this.dialogShow = false
      this.statusDialog = false
      this.reason = ''
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Accept':
          return 'Accept'

        case 'Pending':
          return 'Pending'

        case 'Cancel':
          return 'Cancel'

        case 'Deny':
          return 'Deny'

        case 'Delete':
          return 'Delete'

        default:
          return 'NA'
      }
    },
    renderIf(data) {
      if (data.entryType === 'purInvoice' || data.entryType === 'purOrder' || data.entryType === 'purChallan' || data.entryType === 'salesInvoice' || data.entryType === 'salesOrder' || data.entryType === 'salesChallan' || data.entryType === 'purReturn' || data.entryType === 'salesReturn') {
        return true
      }
    },
    async updateTranId(data) {
      let userData = {
        id: data.id
      }
      let resp = await this.$store.dispatch('updateTranId', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.statusDialog = false
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: this.accountMasterId,
        type: this.type
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/journalBook' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/' + data.type,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'journalBook.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      // this.allJournalBookLists = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    showReasonDialog(data) {
      this.transactionMasterId = data.id
      this.statusData = data.txnStatus
      this.tranModuleType = data.tranModuleType
      this.tranId = data.tranId
      if (data.txnStatus === 'Cancel' || data.txnStatus === 'Deny' || data.txnStatus === 'Delete') {
        this.statusDialog = true
        this.transactionMasterId = data.id
        this.statusData = data.txnStatus
      }
      if (data.txnStatus === 'Accept') {
        this.reason = '-'
        this.updateTransactionStatus()
      }
    },
    async updateTransactionStatus() {
      let data = {
        id: this.transactionMasterId,
        statusType: this.statusData,
        reason: this.reason,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType
      }
      console.log()
      let resp = await this.$store.dispatch('updateTransactionStatus', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.statusDialog = false
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Column,
    DataTable,
    InputText,
    InputMask,
    ReverseDialog,
    Button,
    RadioButton,
    Dialogs
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// journalPendingReport.vue?3ea9168e